/**
 * قالب‌بندیِ عددِ فارسی — یک جا برای کلِ برنامه.
 *
 * چرا: `toLocaleString("fa-IR")` جداکنندهٔ هزارگان را «٬» (U+066C) می‌گذارد؛
 * یک ویرگولِ ریزِ بالا که در اندازه‌های کوچکِ جدول تقریباً دیده نمی‌شود و
 * خواندنِ مبالغِ چندمیلیونی را سخت می‌کند. ارقام فارسی می‌مانند، ولی جداکننده
 * همان **ویرگولِ معمولی** می‌شود — همان چیزی که فیشِ PDF (`pdf_fa.money`) و
 * اکسل هم استفاده می‌کنند، پس نمایشِ وب و چاپ یکی می‌شود.
 *
 * پارسرها (`moneyParser`، `faNorm`) از قبل هر دو جداکننده را می‌پذیرند، پس
 * دادهٔ تایپ‌شدهٔ قدیمی هم می‌شکند.
 */

/** جداکنندهٔ عربیِ هزارگان که خوانا نیست */
const ARABIC_THOUSANDS = "٬";

/** جداکنندهٔ خوانا */
export const THOUSANDS_SEP = ",";

/**
 * عدد → رشتهٔ فارسیِ خوانا.
 * `opts` همان گزینه‌های `Intl.NumberFormat` است (مثلاً maximumFractionDigits).
 */
export function faNum(value, opts) {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  /* ریال واحدِ شکسته ندارد: «۱۵۲٬۰۰۰ و ۳۲ صدم ریال» بی‌معنی است و کاربر صریحاً
     گفت «کلاً بعدِ صفر ممیزی نداریم». پس پیش‌فرض گرد می‌شود؛ هر جا واقعاً اعشار
     لازم بود (نرخِ خط، نسبت) صداکننده خودش `maximumFractionDigits` می‌دهد. */
  const o = opts || { maximumFractionDigits: 0 };
  return n.toLocaleString("fa-IR", o)
    .split(ARABIC_THOUSANDS).join(THOUSANDS_SEP);
}

/**
 * فقط **ارقام** را فارسی می‌کند و بقیهٔ رشته را دست نمی‌زند.
 *
 * چرا جدا از `faNum`: آن یکی رشته را به عدد تبدیل می‌کند و برای چیزهایی مثل
 * ساعتِ «07:23» یا کدِ «00004» رشتهٔ **خالی** برمی‌گرداند — یعنی مقدار بی‌صدا
 * از صفحه غیب می‌شود. (همین باعث شد سلول‌های گریدِ هفتگی خالی دیده شوند.)
 */
export function faDigits(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
}

export default faNum;
